export const PAGE_SIZE = {
    VideosLanding: '15',
    VideoPDP: '10',
    HomeLanding: '10',
}

export const MOBILE_FILTER_DRAWER_NAME = 'videos-mobile-panel'

export const ROW_GROUP_SIZE = 5
